import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlatList = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 36,
	viewBox: "0 0 34 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 0C8.32842 0 9 0.671572 9 1.5V7.5C9 8.32842 8.32842 9 7.5 9H1.5C0.671572 9 0 8.32842 0 7.5V1.5C0 0.671572 0.671572 0 1.5 0H7.5ZM6 6V3H3V6H6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.6414 4.49994C33.6414 3.67152 32.9699 2.99994 32.1414 2.99994H16.5002C15.6718 2.99994 15.0002 3.67152 15.0002 4.49994C15.0002 5.32837 15.6718 5.99994 16.5002 5.99994H32.1414C32.9699 5.99994 33.6414 5.32836 33.6414 4.49994Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.9271 16.4999C32.7556 16.4999 33.4271 17.1715 33.4271 17.9999C33.4271 18.8284 32.7556 19.4999 31.9271 19.4999H16.5002C15.6718 19.4999 15.0002 18.8284 15.0002 17.9999C15.0002 17.1715 15.6718 16.4999 16.5002 16.4999H31.9271Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.9271 29.9999C32.7556 29.9999 33.4271 30.6715 33.4271 31.4999C33.4271 32.3284 32.7556 32.9999 31.9271 32.9999H16.5002C15.6718 32.9999 15.0002 32.3284 15.0002 31.4999C15.0002 30.6715 15.6718 29.9999 16.5002 29.9999H31.9271Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 15C9 14.1716 8.32842 13.5 7.5 13.5H1.5C0.671572 13.5 0 14.1716 0 15V21C0 21.8285 0.671572 22.5 1.5 22.5H7.5C8.32842 22.5 9 21.8285 9 21V15ZM6 16.5V19.5H3V16.5H6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 27C8.32842 27 9 27.6716 9 28.5V34.5C9 35.3285 8.32842 36 7.5 36H1.5C0.671572 36 0 35.3285 0 34.5V28.5C0 27.6716 0.671572 27 1.5 27H7.5ZM6 33V30H3V33H6Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgFlatList);
export { ForwardRef as ReactComponent };
